import React from 'react';

const Spinner = (props) => {
    let classes = "spinner ";
    classes += props.styleName ? props.styleName : "";
    return (
        <span className={classes}>
             <div className="lds-facebook"><div></div><div></div><div></div></div>
            <span className="visually-hidden">Loading...</span>
        </span>
    );
};

export default Spinner;
